import "../../node_modules/.pnpm/vue@3.5.13_typescript@4.9.5/node_modules/vue/dist/vue.runtime.esm-bundler.es.js";
import xss from "xss";
import { defineComponent, openBlock, createElementBlock, createElementVNode as createBaseVNode, Fragment, renderList } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.13/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.es.js";
import { unref } from "../../node_modules/.pnpm/@vue_reactivity@3.5.13/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.es.js";
import { normalizeClass } from "../../node_modules/.pnpm/@vue_shared@3.5.13/node_modules/@vue/shared/dist/shared.esm-bundler.es.js";
const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = { class: "list" };
const _hoisted_3 = ["innerHTML"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "WsSelectOptionWithList",
  props: {
    option: {
      type: Object,
      default: () => ({})
    },
    border: {
      type: Boolean,
      default: true
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["ws-select-option-with-list", { "border q-px-md q-py-sm": __props.border }])
      }, [
        createBaseVNode("p", {
          class: "title",
          innerHTML: unref(xss)(__props.option.label)
        }, null, 8, _hoisted_1),
        createBaseVNode("ul", _hoisted_2, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(__props.option.items, (item) => {
            return openBlock(), createElementBlock("li", {
              key: item,
              innerHTML: unref(xss)(item)
            }, null, 8, _hoisted_3);
          }), 128))
        ])
      ], 2);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=WsSelectOptionWithList.vue.es2.js.map
